import { j as t } from "../../jsx-runtime.BREq8dyb.js";
import { u as y } from "../../sortable.esm.jwEM6DG5.js";
import { faGripDotsVertical as h } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon as A } from "@fortawesome/react-fontawesome";
import { styled as n, IconButton as x, AccordionSummary as D, useThemeProps as P, buttonGroupClasses as q, buttonClasses as j, iconButtonClasses as C } from "@mui/joy";
import { m as k } from "../../lodash.DGoHQECz.js";
import { forwardRef as R } from "react";
const s = "DqSortableAccordionSummary", w = n(x, {
  name: s,
  slot: "grip"
})(), E = n(D, {
  name: s,
  slot: "root"
})(), a = {
  grip: "DqSortableAccordionSummary-grip",
  root: "DqSortableAccordionSummary-root"
}, F = R((i, c) => {
  const {
    children: m,
    id: l,
    slotProps: p,
    ...u
  } = P({
    name: s,
    props: i
  }), {
    grip: e,
    ...d
  } = p || {}, {
    attributes: b,
    listeners: S,
    setActivatorNodeRef: g,
    isSorting: r
  } = y({
    id: l
  }), f = {
    component: "div",
    onKeyDown: (o) => {
      o.target === o.currentTarget && (o.key === "Enter" || o.key === " ") && (o.preventDefault(), o.stopPropagation(), o.target.click());
    },
    sx: {
      // TODO: `cursor`, `pointerEvents` and `userSelect` _could_ behave better (TBD)
      "& > *:not(:first-child)": {
        pointerEvents: r ? "none" : "auto"
      },
      [`&:not(.Mui-selected,[aria-selected="true"],[aria-pressed="true"]):hover:has(.${q.root}:hover,.${j.root}:hover,.${C.root}:hover)`]: {
        backgroundColor: "unset",
        color: "unset"
      },
      cursor: r ? "grabbing" : "pointer"
    },
    ...b
  };
  return /* @__PURE__ */ t.jsxs(E, { className: a.root, ref: c, slotProps: k({
    button: f
  }, d), ...u, children: [
    /* @__PURE__ */ t.jsx(w, { className: a.grip, ref: g, ...S, ...e, sx: {
      cursor: r ? "grabbing" : "grab",
      ...e?.sx
    }, children: /* @__PURE__ */ t.jsx(A, { icon: h }) }),
    m
  ] });
});
export {
  F as default,
  a as dqSortableAccordionSummaryClasses
};
//# sourceMappingURL=DqSortableAccordionSummary.js.map
